import { Routes, Route, type Location } from 'react-router-dom';
import { Home } from './Home';
import { Profile } from './Profile';
import { PostDetail } from './PostDetail';
import { Search } from './Search';
import { Notifications } from './Notifications';

export function InstaflixRoutes({ location }: { location?: Partial<Location> | string }) {
  return (
    <Routes location={location}>
      <Route path="/instaflix" element={<Home />} />
      <Route path="/instaflix/profile/:username" element={<Profile />} />
      <Route path="/instaflix/post/:id" element={<PostDetail />} />
      <Route path="/instaflix/search" element={<Search />} />
      <Route path="/instaflix/notifications" element={<Notifications />} />
    </Routes>
  );
}
